module.exports = "https://cdn.dove.it/_next/static/public/assets/work-with-us/team-doveit.7bb521186fd33e93edcca436b38a1782.jpg";